import BaseService from '@/services/base.service';
import store from '../store'

const API_URL = process.env.VUE_APP_API_URL;
// const ACCOUNT_SLUG = process.env.VUE_APP_ACCOUNT_SLUG;

class CountriesService extends BaseService {
    getCountries() {
        return this.post(API_URL + '/api/v2/countries', {
            account: store.state.account
        }).then(response => {
            if (response.data.status == 'success') {
                return response.data.countries;
            }
        }).catch(err => {
            throw err.response.data;
        })
    }
}

export default new CountriesService();
